import uniqid from "uniqid";

import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { array, enumValues, nullable, number, object, string } from "../../../types/_types";

import { ArticleRef } from "../../articles/types/ArticleRef";
import { OrganizationRef } from "../../organizations/types/OrganizationRef";
import { ProductionRef } from "../../productions/types/Production";
import { WorkRef } from "../../works/types/WorkRef";

import artifactContentTypes from "../constants/artifactContentTypes";
import artifactMarkerTypes from "../constants/artifactMarkerTypes";
import artifactValidationStatuses from "../constants/artifactValidationStatuses";

export const artifactStatus = enumValues(artifactValidationStatuses);
export const artifactMarkerType = enumValues(artifactMarkerTypes);

export const artifactMarker = object({
	id: string().default(() => uniqid()),
	fileId: string(),
	position: number(),
	text: string(),
	type: artifactMarkerType,
});

export const Artifact = FirestoreDocument.extend({
	article: nullable(ArticleRef),
	contentType: nullable(enumValues(artifactContentTypes)),
	duration: number().default(0),
	error: nullable(string()),
	files: array(string()),
	format: nullable(object().passthrough()),
	markers: array(artifactMarker),
	name: string(1),
	producer: nullable(OrganizationRef),
	production: nullable(ProductionRef),
	publisher: nullable(OrganizationRef),
	size: number().default(0),
	status: artifactStatus.default(artifactValidationStatuses.PENDING),
	warnings: array(string()),
	work: nullable(WorkRef),
}).merge(FirestoreLifecycle);
